<template>
  <div class="instrumentTime">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="时间">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="购买名称/划扣项目" label-width="130px">
          <el-input v-model.trim="filters.project" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="项目类别">
          <el-input v-model.trim="filters.projectCategory" clearable placeholder="请输入项目类别"></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model.trim="filters.projectName" clearable placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="门诊">
          <el-select v-model="filters.outpatientService" placeholder="请选择门诊" clearable>
            <el-option v-for="(item) in flags" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="buttonText">
        <!-- <div class="delete" @click="delAll">批量删除</div>
        <div class="addData" @click="add">新增</div> -->
        <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
        <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
        <el-table-column sortable prop="projectCategory" label="项目类别"></el-table-column>
        <el-table-column sortable prop="projectName" label="项目名称"></el-table-column>
        <el-table-column sortable prop="project" label="购买项目/划扣项目"></el-table-column>
        <el-table-column sortable prop="diagnosisName" label="诊断"></el-table-column>
        <el-table-column sortable prop="instrumentName" label="仪器"></el-table-column>
        <el-table-column sortable prop="materialName" label="耗材"></el-table-column>
        <el-table-column sortable prop="outpatientService" label="门诊">
          <template slot-scope="scope">
            <span v-if="scope.row.outpatientService=='1'">是</span>
            <span v-if="scope.row.outpatientService=='0'">否</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="handleName" label="处理名称"></el-table-column>
        <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
        <el-table-column sortable prop="createTime" label="添加时间" width="100"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="forbidden" label="禁用" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="change(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增编辑身份弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="140px">
        <el-form-item label="项目类别">
          <el-input v-model.trim="formData.projectCategory" style="width:95%;" placeholder="请输入项目类别"></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model.trim="formData.projectName" style="width:95%;" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="购买项目/划扣项目">
          <el-input v-model.trim="formData.project" style="width:95%;" placeholder="请输入购买项目/划扣项目"></el-input>
        </el-form-item>
        <el-form-item label="门诊">
          <el-radio-group v-model="formData.outpatientService">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="门诊显示名称">
          <span slot="label" class="label">
            <el-popover popper-class="pop" placement="top" trigger="click" content="门诊显示名称">
              <span slot="reference">门诊显示名称</span>
            </el-popover>
          </span>
          <el-input v-model.trim="formData.outpatientName" style="width:95%;" placeholder="请输入门诊显示名称"></el-input>
        </el-form-item>
        <el-form-item label="处理显示名称">
          <span slot="label" class="label">
            <el-popover popper-class="pop" placement="top" trigger="click" content="处理显示名称">
              <span slot="reference">处理显示名称</span>
            </el-popover>
          </span>
          <el-input v-model.trim="formData.handleName" style="width:95%;" placeholder="请输入处理显示名称"></el-input>
        </el-form-item>
        <div>
          <div v-for="(domain, idx) in formData.sknDiagnosisMenuList" :key="idx">
            <el-form-item label="诊断">
              <div class="flex">
                <el-input style="width:90%;" v-model="domain.diagnosisName" placeholder="请输入诊断" @input="testSX"></el-input>
                <el-button size="mini" type="danger" @click.prevent="edit(domain,idx)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="对应名称">
              <el-input style="width:90%;" v-model="domain.correspondingName" placeholder="请输入对应名称" @input="testSX"></el-input>
            </el-form-item>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="addList" type="primary" size="mini">新增诊断</el-button>
          </el-form-item>
        </div>
        <el-form-item label="耗材">
          <el-select filterable remote :filter-method="empMatch" multiple v-model="formData.materialNo" placeholder="请选择耗材" style="width:95%;">
            <el-option v-for="(item) in materialsList" :key="item.id" :label="item.menuName" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仪器">
          <el-select multiple filterable remote :filter-method="insMatch" v-model="formData.instrumentNo" placeholder="请选择仪器" style="width:95%;">
            <el-option v-for="(item) in instrumentList" :key="item.id" :label="item.instrumentName" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="治疗指数">
          <el-input oninput="value=value.replace(/[^\d.]/g, '')" style="width:90%;" v-model="formData.therapeuticIndex" placeholder="请输入治疗指数" @input="testSX"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'project',
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
        outpatientService: '',
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      formData: {},
      tableHeight: "",
      isId: '',
      flags: [
        {
          name: '是',
          id: '1'
        },
        {
          name: '否',
          id: '0'
        },
      ],
      instruments: [],
      instrumentList: [],
      materials: [],
      materialsList: []

    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 360
    api.requestQuiet("/menu/findInstrumentMenuByCodeList", { departmentCode: '001' }, (res) => {
      if (res.result == true) {
        this.instruments = res.data
        this.instrumentList = res.data
      }
    }, (err) => { });
    api.requestQuiet("/skn/findConsumableMenuByCodeList", { departmentCode: '001' }, (res) => {
      if (res.result == true) {
        this.materials = res.data
        this.materialsList = res.data
      }
    }, (err) => { });
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    },
  },
  methods: {
    empMatch(val) {
      this.materialsList = _g.paramMatch(this.materials, this.materialsList, val, 'menuName')
    },
    insMatch(val) {
      this.instrumentList = _g.paramMatch(this.instruments, this.instrumentList, val, 'instrumentName')
    },
    testSX() {
      this.$forceUpdate()
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增项目
    add() {
      this.dialogFormVisible = true
      this.isId = ''
      // 新增置空
      this.formData = {
        projectName: "",
        projectCategory: "",
        project: "",
        outpatientService: '',
        sknDiagnosisMenuList: [{
          diagnosisName: '',
          correspondingName: '',
        }],

      }
    },

    handleEdit(index, row) {
      this.isId = row.id
      this.dialogFormVisible = true
      let querys = {
        id: row.id,
      }
      api.request('/skn/findProjectMenuById', querys, (res) => {
        this.formData = res.data
        if (this.formData.instrumentNo) {
          this.formData.instrumentNo = _g.turnNum(this.formData.instrumentNo)
        }
        if (this.formData.materialNo) {
          this.formData.materialNo = _g.turnNum(this.formData.materialNo)
        }
      })
    },
    doAddgoods() {
      if (this.formData.instrumentNo) {
        this.formData.instrumentNo = this.formData.instrumentNo.toString()
      }
      if (this.formData.materialNo) {
        this.formData.materialNo = this.formData.materialNo.toString()
      }
      this.formData.createBy = Lockr.get('skinEmpId')
      if (this.isId) {
        api.requestQuiet("/skn/updateProjectMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", '修改成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      } else if (!this.isId) {
        api.requestQuiet("/skn/createProjectMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", '添加成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      }

    },
    // 删除项目
    del(index, row) {
      let querys = {
        id: row.id,
      }
      this.$confirm('确定要该条数据吗？', '删除项目', {
        center: true
      })
        .then((res) => {
          api.request("/skn/deleteProjectMenuById", querys, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })
    },
    // 批量删除
    delAll() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        console.log(item)
        id.push(item.id);
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet(
            "/skn/deleteProjectMenuAll", {
              idList: id.toString(),
            },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    change(index, row) {
      let data = {
        id: row.id
        // 0：正常 1：禁用
      }
      api.request("/skn/updateProjectMenuForbidden", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "状态修改成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "状态修改失败")
          this.query(this.filters.pagination.page)
        }
      })
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        project: this.filters.project,
        projectCategory: this.filters.projectCategory,
        projectName: this.filters.projectName,
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
        outpatientService: this.filters.outpatientService,
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.request('/skn/findProjectMenuPage', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.filters.pagination.total = parseInt(res.data.count)
      })
    },
    // 编辑时删除诊断
    edit(item, listIndex) {
      var index = this.formData.sknDiagnosisMenuList.indexOf(item)
      if (index !== -1) {
        this.formData.sknDiagnosisMenuList.splice(listIndex, 1)
      }
      this.$forceUpdate()
    },
    // 编辑时新增诊断
    addList() {
      this.formData.sknDiagnosisMenuList.push({
        diagnosisName: '',
        correspondingName: '',
        key: Date.now()
      });
      this.$forceUpdate()
    },
  },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
.label {
  cursor: pointer;
}
</style>
<style>
.pop {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
}
.popper__arrow::after {
  border-top-color: #dcdfe6;
}
</style>
